import Reveal from './Reveal';
import { playSteps } from '../content';

export default function PlayGuide() {
  return (
    <section id="play" className="scroll-mt-24 bg-[#FBF9F4] py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <p className="font-display text-xs tracking-[0.35em] text-rose-500 uppercase">Advanced Play · 进阶玩法</p>
            <h2 className="mt-3 text-2xl font-bold tracking-tight text-stone-900 md:text-4xl">从会用，到玩透</h2>
            <p className="mt-4 text-sm leading-7 text-stone-500 md:text-[15px]">
              基础操作熟练之后，这四个进阶技巧能让你看得更全、更省时间，把吃瓜软件玩出彩。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
          <Reveal className="order-2 lg:order-1">
            <div className="overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20flat%20illustration%20of%20a%20focused%20person%20at%20a%20tidy%20desk%20managing%20several%20organized%20tracking%20boards%20with%20priority%20sliders%20and%20exported%20note%20sheets%2C%20warm%20cream%20paper%20background%2C%20sage%20green%2C%20amber%20and%20soft%20rose%20accents%2C%20minimal%20magazine%20editorial%20aesthetic%2C%20soft%20paper%20grain%2C%20calm%20and%20focused%2C%20airy%20composition&width=1000&height=860&seq=play-master-2026&orientation=squarish"
                alt="吃瓜软件进阶玩法：多专题合并追踪与信息流权重调整插画"
                title="吃瓜软件 · 进阶玩法技巧"
                className="h-[360px] w-full object-cover object-top md:h-[480px]"
              />
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <ol className="flex flex-col">
              {playSteps.map((step, i) => (
                <Reveal key={step.num} delay={i * 90}>
                  <li className="group flex gap-5 border-b border-black/5 py-6 first:pt-0">
                    <span className="font-display text-2xl font-semibold text-emerald-600/70 transition-colors group-hover:text-emerald-700">
                      {step.num}
                    </span>
                    <div>
                      <h3 className="text-base font-semibold text-stone-900">{step.title}</h3>
                      <p className="mt-1.5 text-sm leading-6 text-stone-500">{step.desc}</p>
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}